// Module
var code = "<div class=\"product-read-more__label\"> <span class=\"product-read-more__label--collapsed\" system-dictionary=\"ReadMore\"></span> <span class=\"product-read-more__label--expanded\" system-dictionary=\"ReadLess\" ng-cloak></span> </div>";
// Exports
module.exports = code;